export default "__VITE_ASSET__BY$12NpC__"